module.exports = __webpack_public_path__ + "img/workout-notebook_B095Q5L1YY.a4fbc91f.jpg";